import Navigation from 'layout/drawer/content/navigation/Navigation.tsx';

const DrawerContent = () => (
  <div className="flex-grow overflow-hidden">
    <div className="h-full overflow-auto">
      <Navigation />
    </div>
  </div>
);

export default DrawerContent;
